import React, { useContext } from "react";
import _ from "lodash";
import DashboardToolBox from "./ToolBox";
import { UserContext } from "../../context/UserContext";
import { SummaryContext } from "../../context/SummaryContext";

const DashboardToolBoxWrapper = () => {
  const { userRole } = useContext(UserContext);
  const { job } = useContext(SummaryContext);

  return _.isEmpty(userRole) || userRole === "adminwithreadaccess" || userRole === "mediarequest"
  || userRole === "cr_api" || ((userRole === 'superadmin'  || userRole === 'globaladmin'|| userRole === 'requestor' || userRole === 'ops') && (_.get(job, 'jobType') === 'CONTENT_REQUEST_API' ||  _.get(job, 'jobType') === 'MEDIA_REQUEST')) ? null : (
    <DashboardToolBox Selected={true} mode="summary" />
  );
};
export default DashboardToolBoxWrapper;
